import axios from 'axios';
import {
    getJwtCookie,
    setJwtCookie,
} from '../../utils/cookie-utils';

export default class AuthService{
    constructor( baseURL ){
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        const jwt = getJwtCookie();

        if( jwt ){
            headers.Authorization = `Bearer ${jwt}`;
        }

        this.instance = axios.create( {
            baseURL,
            headers,
            withCredentials: true
        } );
    }

    createSession(){
        return this.instance.get( '/v1/idm/verify' )
            .then( res => {
                setJwtCookie( res.data.access_token );
                return Promise.resolve( res );
            } );
    }

    validate(){
        return this.instance.get( '/v1/session/verify' );
    }

    getUserDetails(){
        return this.instance.get( '/v1/idm/user-details' );
    }

    extendSession(){
        return this.instance.get( '/v1/session/extend' )
            .then( res => {
                setJwtCookie( res.data.access_token );
                return Promise.resolve( res );
            } );
    }
}
